// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pS8E","top":"styles_top__35JLQ","left":"styles_left__1H5x3","description":"styles_description__1D7LU"};